import React from "react";
import authenticity from "../content/authenticity.json";

const AuthenticityPage = () => {
  return (
    <main data-testid="authenticity-page" className="bg-ivory">
      <section className="pt-32 md:pt-36 pb-16 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center">
          <div className="md:col-span-7">
            <p className="text-xs tracking-[0.32em] uppercase font-medium text-muted_gold">
              {authenticity.overline}
            </p>
            <h1 className="mt-5 font-heading font-normal text-charcoal text-5xl sm:text-6xl md:text-7xl leading-[1.05] tracking-tight">
              {authenticity.heading}
              <span className="italic">{authenticity.headingItalic}</span>
            </h1>
            <div className="mt-6 w-12 h-px bg-muted_gold" />
            <p className="mt-8 text-charcoal-soft text-lg leading-relaxed max-w-xl">
              {authenticity.intro}
            </p>
          </div>
          <div className="md:col-span-5">
            <div className="aspect-square overflow-hidden border border-charcoal/15 max-w-[420px] md:ml-auto">
              <img
                src={authenticity.placeholderImage}
                alt="Sanskrit scholarly process — supporting imagery"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pb-24 md:pb-28 max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">
          {authenticity.pillars.map((p) => (
            <div
              key={p.no}
              data-testid={`pillar-${p.no.toLowerCase()}`}
              className="border-t border-charcoal/10 pt-8"
            >
              <p className="font-accent text-muted_gold text-base tracking-[0.3em] font-medium">
                {p.no}
              </p>
              <h3 className="mt-4 font-heading font-normal text-3xl md:text-4xl text-charcoal">
                {p.title}
              </h3>
              <p className="mt-4 text-charcoal-soft text-base leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default AuthenticityPage;
